import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { UserDetailsService } from 'src/app/services/user/user-details.service';
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { AdminService } from 'src/app/services/admin.service';
import { apiUrl } from "../../../global/global";
import { chatEnvironment } from "../../../../environments/chatEnvironment";

interface SendMessageParams {
  message?: string;
  currentUserChat: any;
  fileName?: string;
  fileType?: string;
}

@Injectable({
  providedIn: "root"
})
export class ChatService {
  firebaseUsers = chatEnvironment.users;
  firebaseMessage = chatEnvironment.messages;
  deleteMessage= chatEnvironment.deleteMessages;
  firebaseChats = chatEnvironment.chats;
  firebaseJobs = chatEnvironment.jobs;
  firebaseNotification = chatEnvironment.notifications;
  limit = 5;
  skip = 1;
  private _usersTableName: string = this.firebaseUsers + '/';
  private _jobsTableName: string = this.firebaseJobs + '/';
  private _chatsTableName: string = this.firebaseChats + '/';
  private _messagesTableName: string = this.firebaseMessage + '/';
  private _notificationsTableName: string = this.firebaseNotification + '/';
  private _jobDetails: any;
  private _userDetails: any;
  private messageListener: any;

  constructor(private _dbInstance: AngularFireDatabase, private router: Router, private toastrService: ToastrService, private api: AdminService) { }

  setUserDetails(userDetails: any) {
    this._userDetails = userDetails;
  }

  getChatsDialogObserverable(userId: string) {
    return this._dbInstance.list('Chats/', query => query.orderByChild('user_id')
      .equalTo(userId)).valueChanges();
  }

  getMessagesObserveable(currentUserChat: any) {
    // firebase code
    this.markAsReadToOpenChat(currentUserChat);
    // return this._dbInstance.list(`${this.firebaseMessage}/${currentUserChat.chat_dialog_id}`, query => query.limitToLast(1)).valueChanges();
    return this._dbInstance.list('Messages/' + currentUserChat.chat_dialog_id, query => query.orderByChild("chat_dialog_id")
      .equalTo(currentUserChat.chat_dialog_id)
      .limitToLast(500)).valueChanges();
  }

  deleteSingleMsg(chat_dialog_id, message_id) {
    // firbase
    this._dbInstance.object(`${this.firebaseMessage}/${chat_dialog_id}/${message_id}`).remove();
    var msg = this._dbInstance.list(`${this.firebaseMessage}/${chat_dialog_id}`, query => query.limitToLast(1)).valueChanges().subscribe(x => {
      this._chatsTableWithChatIdRef(chat_dialog_id).update(this._updateLastMessageInChats(x[0]));
      msg.unsubscribe();
    })
  }

  initiateChat(jobDetails: any) {
    this._jobDetails = jobDetails;
    return new Promise((resolve, rejects) => {
      var chatDialogId = this.jobId + ',' + this.userId;
      this._chatsTableWithChatIdRef(chatDialogId).query.ref.get().then((x) => {
        console.log(x);
        if (x.exists()) {
          this.deleteStatusUpdate(chatDialogId, this.jobId, this.userId)
          resolve(x.val());
        } else {
          this._chatsTableRef.set(this._chatObjBody);
          this._addUpdateUserInUsers();
          this._addUpdateJobInJobs();
          resolve(this._chatObjBody);
        }
      });
    })
  }
  // Method to send message or file
  sendMessage({ message, currentUserChat, fileName, fileType }: SendMessageParams): void {
    var messageBody = this._messageBody;
    if (message) {
      messageBody.message = message;
    }
    else if (fileName) {
      messageBody.attachment_url = fileName;
    }
    messageBody.message_type = message ? 1 : fileType!.includes('image') ? 2 : 3;
    this._messageTableChildRef(currentUserChat.chat_dialog_id + '/' + messageBody.message_id).set(messageBody);
    this._updateLastMessageAndUnreadInChatsTable(currentUserChat, messageBody);
    this._notificationTableChildRef(messageBody.message_id).set(messageBody);
    this.removeMessage(currentUserChat.chat_dialog_id, messageBody.message_id)
  }

  removeMessage(chat_dialog_id, message_id) {
    // alert()
    // console.log('messageListener', chat_dialog_id)

    // if (this.messageListener) {
    //   this.messageListener.unsubscribe();
    // }
    // console.log('messageListener', this.messageListener)
    // this.messageListener = this._dbInstance.list(`${this.firebaseMessage}`,
    //   query => query
    //     .orderByChild("chat_dialog_id")
    //     .equalTo(chat_dialog_id)
    //   //.limitToLast(10)
    // ).valueChanges().subscribe(list => {
    //   let chatDialog = list ? list[0] : [];
    //   console.log('chatDialog', chatDialog)
    // })

    // setTimeout(() => {
    // this._dbInstance.object(`${this.firebaseMessage}/${chat_dialog_id}/${message_id}`).remove();
    // }, 10000);

  }


  // Clear User chat
  clearUserChat(currentUserChat) {
    // firebase code

    this._chatsTableWithChatIdRef(currentUserChat.chat_dialog_id).update({
      'clear_chat_time': {
        [this.userId]: this.currentTime,
        [this.jobId]: currentUserChat.clear_chat_time[this.jobId],
      }
    });
  }

  // Block/Unbock User
  blockUnblockUser(currentUserChat) {
    this._chatsTableWithChatIdRef(currentUserChat.chat_dialog_id).update({
      'block_status': {
        [this.userId]: currentUserChat.block_status[this.userId] == 0 ? 1 : 0,
        [this.jobId]: currentUserChat.block_status[this.jobId],
      }
    });
  }

  deleteStatusUpdate(chatDialogId, jobId, userId) {
    this._dbInstance.object(`${this.firebaseChats}/${chatDialogId}`).update({
      'delete_status': {
        [jobId]: 0,
        [userId]: 0,
      },
    });
  }

  deleteUser(currentUserChat, userType) {
    this._dbInstance.object(`${this.firebaseChats}/${currentUserChat.chat_dialog_id}`).update({
      'delete_status': {
        [currentUserChat.user_id]: userType == "user" ? 1 : currentUserChat.delete_status[currentUserChat.user_id] ? currentUserChat.delete_status[currentUserChat.user_id] : 0,
        [currentUserChat.job_id]: userType == "recruiter" ? 1 : currentUserChat.delete_status[currentUserChat.job_id] ? currentUserChat.delete_status[currentUserChat.job_id] : 0,
      },
    });
    return true
  }

  markAsReadToOpenChat(currentUserChat: any) {
    this._updateUnreadCountInChatsTable(currentUserChat);
  }

  // Add/Update user record 
  private _addUpdateUserInUsers() {
    this._usersTableRef.query.ref.get().then((snapshot) => {
      if (snapshot.exists()) {
        this._usersTableChildRef('/chat_dialog_ids').update(this._childDialogObj); // if user exist then add new chat_dialog_id for new job
      } else {
        this._usersTableRef.set(this._userTableObj); // else create new user node in users
      }
    }).catch((error) => {
      console.error(error);
    });
  }

  // Add/Update Job record 
  private _addUpdateJobInJobs() {
    this._jobsTableRef.query.ref.get().then((snapshot) => {
      if (snapshot.exists()) {
        this._jobsTableChildRef('/chat_dialog_ids').update(this._childDialogObj); // if Job node exist then add new chat_dialog_id for new user
      } else {
        this._jobsTableRef.set(this._userTableObj); // else create new job node in jobs
      }
    }).catch((error) => {
      console.error(error);
    });
  }

  private _updateLastMessageAndUnreadInChatsTable(currentUserChat: any, message: any) {
    Object.keys(currentUserChat.unread_count).forEach((key) => {
      currentUserChat.unread_count[key] = key == this.userId ? 0 : currentUserChat.unread_count[key] + 1;
    })
    message.unread_count = currentUserChat.unread_count;
    this._chatsTableWithChatIdRef(currentUserChat.chat_dialog_id).update(this._updateLastMessageInChats(message));
  }

  private _updateUnreadCountInChatsTable(currentUserChat: any) {
    Object.keys(currentUserChat.unread_count).forEach((key) => {
      currentUserChat.unread_count[key] = key == this.userId ? 0 : currentUserChat.unread_count[key];
    })
    this._chatsTableWithChatIdRef(currentUserChat.chat_dialog_id).update(currentUserChat);
  }
  private get _chatsTableRef() { return this._dbInstance.object(this._chatsTableName + this.chatDialogId); }
  private get _jobsTableRef() { return this._dbInstance.object(this._jobsTableName + this.jobId); }

  private get _usersTableRef() { return this._dbInstance.object(this._usersTableName + this.userId); }

  private get _messagesTableRef() { return this._dbInstance.object(this._messagesTableName + this.chatDialogId); }


  // Get reference of any chat from chats table by passing chat id.
  private _chatsTableWithChatIdRef(chatId: string) { return this._dbInstance.object(this._chatsTableName + chatId); }

  // Get reference of any child from user table by passing child key name
  private _usersTableChildRef(childKey: string) { return this._dbInstance.object(this._usersTableName + this.userId + childKey); }

  // Get reference of any child from jobs table by passing child key name
  private _jobsTableChildRef(childKey: string) { return this._dbInstance.object(this._jobsTableName + this.jobId + childKey); }

  // Get reference of any child from messages table by passing child key name
  private _messageTableChildRef(childKey: string) { return this._dbInstance.object(this._messagesTableName + childKey); }

  // Get reference of any child from notifications table by passing child key name
  private _notificationTableChildRef(childKey: string) { return this._dbInstance.object(this._notificationsTableName + childKey); }


  // getters for jobs
  private get jobId() { return this._jobDetails?.JobPost?.id; }

  private get jobTitle() { return this._jobDetails?.JobPost?.jobTitle; }

  private get jobImage() { return this._jobDetails?.recruiter?.profileImage || ""; }

  private get jobCreatedCompany() { return this._jobDetails?.recruiter?.companyName; }

  // private get userblock() { return this._jobDetails?.recruiter?.companyName; }
  // private get jobblock() { return this._jobDetails?.recruiter?.companyName; }

  // getter for user details
  // get userDetails() { return this.userDetailsService.userDetails };

  // getters for user
  get userId() { return this._userDetails?.id; }

  private get userName() { return this._userDetails?.name; }



  private get userPic() { return this._userDetails?.profileImage; }

  //getter for creating chat dialog id
  private get chatDialogId(): string {
    return this.jobId + ',' + this.userId;
  }

  //getter for current time in milliseconds
  public get currentTime() { return Date.now() }

  //getter for child_dialog_id's object
  private get _childDialogObj(): any {
    return { [this.chatDialogId]: this.chatDialogId };
  }

  //getter for message key from messages table
  private get _messageKey(): string {
    return this._messagesTableRef.query.ref.push().key || '';
  }

  //getter for chats body
  private get _chatObjBody(): any {
    return {
      'chat_dialog_id': this.chatDialogId,
      'name': {
        [this.userId]: this.userName,
        [this.jobId]: this.jobTitle,
      },
      'pic': {
        [this.userId]: this.userPic,
        [this.jobId]: this.jobImage,
      },
      'user_name': this.userName,
      'user_pic': this.userPic,
      'user_id': this.userId,
      'company_name': this.jobCreatedCompany,
      'job_id': this.jobId,
      'job_name': this.jobTitle,
      'job_pic': this.jobImage,
      'last_message': {
        [this.userId]: '',
        [this.jobId]: '',
      },
      'last_message_time': this.currentTime,
      'last_message_id': '',
      'last_message_type': 0,
      'last_message_sender_id': '',
      'unread_count': {
        [this.userId]: 0,
        [this.jobId]: 0,
      },
      'clear_chat_time': {
        [this.userId]: this.currentTime,
        [this.jobId]: this.currentTime,
      },
      'block_status': {
        [this.userId]: 0,
        [this.jobId]: 0,
      },
      'delete_status': {
        [this.userId]: 0,
        [this.jobId]: 0,
      },

    };
  }



  //getter for message body
  private get _messageBody() {
    return {
      'message_id': this._messageKey,
      'message': '',
      'message_type': 1,
      'message_time': this.currentTime,
      'firebase_message_time': this.currentTime,
      'chat_dialog_id': this.chatDialogId,
      'sender_id': this.userId,
      'attachment_url': '',
      'receiver_id': this.jobId,
    };
  }
  private _updateLastMessageInChats(message: any) {

    return {
      'last_message': { [this.userId]: message?.message, [this.jobId]: message?.message },
      'last_message_time': message?.message_time,
      'last_message_id': message?.message_id,
      'last_message_type': message?.message_type,
      'last_message_sender_id': message?.sender_id,
      'unread_count': message?.unread_count,
    };
  }

  private get _userTableObj(): any {
    return {
      'user_id': this.userId,
      'chat_dialog_ids': { [this.chatDialogId]: this.chatDialogId },
    }
  }


} 